import React, { useEffect, useState } from 'react';
import useAxios from 'axios-hooks';
import { PrimaryButton, Checkbox } from '@fluentui/react';
import { Field, Form, Formik } from 'formik';
import { useParams, useHistory } from 'react-router-dom';
import TextField from '../../../../Forms/TextField';
import Toast from '../../../../Forms/Toast';
import FeatureSummary from '../../../../Util/FeatureSummary';

const newCoBrandSettingsObject = {
    themedMonthlyTaskId: null,
    year: '',
    month: '',
    themeName: '',
    international: false,
    articleSlug1: '',
    articleSlug2: '',
    videoSlug: '',
    infographicSlug: '',
    courseSlug: '',
    toolId1: '',
    toolId2: '',
};

const WizardPage = () => {
    const [showToast, setShowToast] = React.useState(false);
    const [showError, setShowError] = React.useState(false);
    const history = useHistory();
    const { themedMonthlyTaskId: idFromParams } = useParams();

    const [{ data: domain, loading: loading }, getDisclaimer] = useAxios(
        { url: `/internal/cobrand/monthly-task/${idFromParams}`, method: 'GET' },
        { manual: true },
    );

    useEffect(() => {
        if (idFromParams) {
            getDisclaimer();
        }
    }, [idFromParams]);

    const [{ data, loading: submitting }, submitForm] = useAxios(
        { url: `/internal/cobrand/monthly-task/update` },
        { manual: true },
    );

    return (
        <Formik
            initialValues={domain ? domain : newCoBrandSettingsObject}
            onSubmit={async (values, { resetForm }) => {
                setShowError(false);
                const cleanedValues = Object.fromEntries(
                    Object.entries(values).map(([key, value]) => [key, value === '' ? null : value])
                );
                let result = await submitForm({
                    url: idFromParams ? "/internal/cobrand/monthly-task/update" : "/internal/cobrand/monthly-task/create",
                    method: "POST",
                    data: cleanedValues,
                });

                if (!result.isAxiosError) {

                    if(!idFromParams){
                        history.push(`/cobrand-settings-feature/monthly-tasks/${result.data}/wizard`)
                        setShowToast(true);
                    }else{
                        setShowToast(true);
                    }
                    
                }else{
                    setShowError(true);
                }
            }}
            validate={(values) => {
                const errors = {};
                if (!values.themeName) {
                    errors.themeName = "Theme Name is required";
                }
                if (!values.year) {
                    errors.year = "Year is required";
                }
                if (!values.month) {
                    errors.month = "Month is required";
                }
                return errors;
            }}
            validateOnBlur
            enableReinitialize={true}
            isInitialValid={false}
        >
            {({ errors, values, setFieldValue, handleSubmit }) => (
                <Form style={{ maxWidth: "500px", marginBottom: 500 }}>
                    <h4>Edit Monthly Task</h4>
                    {showError && <div style={{ color: 'rgb(164, 38, 44)' }}>An error has occurred.</div>}

                    <TextField label="Year" name="year" type="number" value={values.year} onChange={(e, v) => setFieldValue('year', v)} errorMessage={errors.year} />
                    <TextField className="mt5" label="Month" name="month" type="number" value={values.month} onChange={(e, v) => setFieldValue('month', v)} errorMessage={errors.month} />
                    <TextField className="mt5" label="Theme Name" name="themeName" value={values.themeName} onChange={(e, v) => setFieldValue('themeName', v)} errorMessage={errors.themeName} />
                    <Checkbox className='mt10' label="International" checked={values.international} onChange={(e, v) => setFieldValue('international', v)} />
                    <TextField className="mt5" label="Article Slug 1" name="articleSlug1" value={values.articleSlug1} onChange={(e, v) => setFieldValue('articleSlug1', v)} />
                    <TextField className="mt5" label="Article Slug 2" name="articleSlug2" value={values.articleSlug2} onChange={(e, v) => setFieldValue('articleSlug2', v)} />
                    <TextField className="mt5" label="Video Slug" name="videoSlug" value={values.videoSlug} onChange={(e, v) => setFieldValue('videoSlug', v)} />
                    <TextField className="mt5" label="Infographic Slug" name="infographicSlug" value={values.infographicSlug} onChange={(e, v) => setFieldValue('infographicSlug', v)} />
                    <TextField className="mt5" label="Course Slug" name="courseSlug" value={values.courseSlug} onChange={(e, v) => setFieldValue('courseSlug', v)} />
                    <TextField className="mt5" label="Tool ID 1" name="toolId1" type="number" value={values.toolId1} onChange={(e, v) => setFieldValue('toolId1', v)} />
                    <TextField className="mt5" label="Tool ID 2" name="toolId2" type="number" value={values.toolId2} onChange={(e, v) => setFieldValue('toolId2', v)} />

                    <PrimaryButton
                        className="mt20"
                        onClick={() => handleSubmit()}
                        text={idFromParams ? "Update" : 'Create'}
                        disabled={!values.themeName || !values.year || !values.month}
                    />

                    <Toast show={showToast} message="Saved!" onClose={() => setShowToast(false)} />
                    <FeatureSummary
                        label="About Monthly Tasks"
                        summary="Create themed monthly tasks that appear on user dashboards. Configure the year, month, theme name, and specify content slugs for articles, videos, infographics, courses, and tools. Use the 'International' toggle for content targeting international users."
                    />
                </Form>
            )}
        </Formik>
    );
};

export default WizardPage;
